import axios from "axios";
import React, { useEffect, useState } from "react";
import index from "react-typical";
import Header from "../Course/Header";
import Footer from "../Footer";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import UpdateIcon from "@material-ui/icons/Update";
import "./SelectAllAdmin.css";
import { Button, IconButton, TextField } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import RefreshIcon from "@material-ui/icons/Refresh";

const initialState = {
  username: "",
  password: "",
};
function SelectAllAdmin() {
  const [loginData, setLoginData] = useState(initialState);
  const [listAdmins, setListAdmins] = useState([]);

  // const [adminname, setAdminname] = useState("");
  // const [password, setPassword] = useState("");

  const submitUser = () => {
    // console.log(adminname);
    // console.log(password);

    // const data = { username: adminname, password: password };
    var config = {
      method: "post",
      url: "https://localhost:44300/api/CreateAdminAccount/PostNewAdminAccount",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("Token")}`,
        "Content-Type": "application/json",
      },
      data: loginData,
    };
    axios(config)
      .then(function (response) {
        alert(response.data);
      })
      .catch(function (error) {
        alert(error);
      });
    setLoginData(initialState);
  };

  const deleteAdmin = (id) => {
    axios
      .get(
        "https://localhost:44300/api/CreateAdminAccount/GetDeleteAdmin?id=" + id
      )
      .then(function (response) {
        // useEffect();
        alert("Delete Admin Account complete!");
      })
      .catch(function (error) {
        alert("There are something wrong" + error);
      });
  };

  useEffect(() => {
    var config = {
      method: "get",
      url: "https://localhost:44300/api/CreateAdminAccount/GetAllAdminAccount",
      headers: {
        Authorization:
          // " Bearer -kmOaBpDRhUr0UjNJQ0MIh85tOnOaBntqpyQCvPuUk-62z9DsrzjKJwZsFS6fdKJqH8l0XHU6uhASxLcG6WAIK9pa_3FitDNq2lKSE1zcgA_6vD7GE6pwpi2LBXT3VLc_Eyjpya87hsfKiG5MG5cHUIsEioeaUM9DSKOeUl0a3LWSNAuwA015pOjszGio51Lr4LK1QNOZn0n4F13lwp24pqLBHF9sDTg5ktzzKvDiFQ",
          `Bearer ${localStorage.getItem("Token")}`,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(response.data);
        setListAdmins(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <div>
      <Header />
      <div className="selectAdmin">
        <hr
          style={{
            width: "95%",
            marginTop: "-30px",
            marginBottom: "30px",
            marginLeft: "2.5%",
          }}
        />
        <div className="addAdmin">
          <h3>Add Admin Account</h3>
          <TextField
            type="text"
            variant="outlined"
            color="primary"
            label="Admin name"
            value={loginData.username}
            onChange={(e) =>
              setLoginData({ ...loginData, username: e.target.value })
            }
          ></TextField>
          &nbsp;
          <TextField
            type="text"
            variant="outlined"
            color="primary"
            label="Password"
            value={loginData.password}
            onChange={(e) =>
              setLoginData({ ...loginData, password: e.target.value })
            }
          ></TextField>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ArrowUpwardIcon />}
            onClick={submitUser}
            disabled={(!loginData.username, !loginData.password)}
          >
            Submit
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            color="primary"
            startIcon={<RefreshIcon />}
            disabled={(!loginData.username, !loginData.password)}
            onClick={() => setLoginData(initialState)}
          >
            refresh
          </Button>
          <br />
          <br />
        </div>
        <br />
        <h1>This is all Admin Accounts</h1>
        <div className="table">
          <table>
            <thead>
              <th className="table-th" style={{ width: "70px" }}>
                ID
              </th>
              <th className="table-th">Admin Name</th>
              <th className="table-th">Admin password</th>
              <th
                className="table-th"
                style={{ width: "70px" }}
                onClick={deleteAdmin}
              >
                Delete
              </th>
              <th className="table-th" style={{ width: "70px" }}>
                Update
              </th>
            </thead>
            <tbody>
              {listAdmins?.map((each, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{each.username}</td>
                  <td>{each.password}</td>
                  <td>
                    <IconButton onClick={() => deleteAdmin(each.id)}>
                      <DeleteForeverIcon style={{ color: "red" }} />
                    </IconButton>
                  </td>
                  <td>
                    <UpdateIcon style={{ color: "green" }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br />
          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SelectAllAdmin;
